module.exports = __webpack_public_path__ + "img/Muffin.30019d11.jpg";